import * as React from "react";
const SvgFiBrandsWalmart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-walmart_svg__a)">
      <path d="M11.997 8.08c.562 0 1.025-.292 1.088-.67l.556-6.279C13.641.51 12.914 0 12 0c-.913 0-1.639.51-1.639 1.131l.555 6.279c.061.378.524.67 1.085.67zM8.604 10.04c.282-.485.26-1.033-.037-1.275l-5.161-3.62c-.536-.31-1.341.064-1.798.855s-.377 1.675.159 1.985l5.714 2.66c.358.134.844-.121 1.125-.607zM15.394 10.038c.281.486.766.74 1.124.608l5.715-2.661c.538-.31.615-1.194.16-1.985-.459-.792-1.265-1.166-1.8-.855l-5.16 3.62c-.296.243-.318.79-.037 1.276zM11.997 15.923c.562 0 1.025.29 1.088.668l.556 6.279c0 .622-.727 1.13-1.642 1.13-.913 0-1.639-.508-1.639-1.13l.555-6.28c.061-.377.525-.667 1.085-.667zM15.394 13.962c.281-.487.766-.74 1.124-.605l5.715 2.658c.538.31.615 1.195.16 1.987-.459.789-1.265 1.164-1.8.855l-5.16-3.617c-.296-.246-.318-.792-.037-1.278zM8.604 13.96c.282.487.26 1.034-.037 1.279l-5.161 3.617c-.536.31-1.341-.065-1.798-.855-.458-.792-.377-1.676.159-1.987l5.714-2.658c.358-.135.844.118 1.125.605z" />
    </g>
    <defs>
      <clipPath id="fi-brands-walmart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsWalmart;
